module.exports = __webpack_public_path__ + "img/howitworksimg4.3c969b39.webp";